
// src/components/media/MediaTile.jsx
import React, { useState } from "react";
import MediaViewer from "./MediaViewer";

/**
 * Uniform image/video tile.
 * - Shows first video frame (no black box) via onLoadedMetadata seek.
 * - Adds controls + playsInline so mobile browsers render + play correctly.
 * - Infers a reasonable MIME type from the URL.
 * - Tap to open fullscreen viewer with pinch-to-zoom.
 */
const MediaTile = ({ src, isVideo = false, className = "" }) => {
  const [showViewer, setShowViewer] = useState(false);

  const wrap = {
    position: "relative",
    width: "100%",
    aspectRatio: "1 / 1",
    borderRadius: 12,
    overflow: "hidden",
    background: "#000",
    cursor: "pointer",
  };
  const media = { width: "100%", height: "100%", objectFit: "cover", display: "block" };

  const tile = !isVideo ? (
    <div style={wrap} className={className} onClick={() => setShowViewer(true)}>
      <img
        src={src}
        alt=""
        style={media}
        onError={(e) => (e.currentTarget.src = "/event.png")}
      />
    </div>
  ) : (() => {
    const lower = (src || "").toLowerCase();
    const type =
      lower.endsWith(".webm") ? "video/webm" :
      lower.endsWith(".mov")  ? "video/quicktime" :
      lower.endsWith(".ogv")  ? "video/ogg" :
                                 "video/mp4";
    return (
      <div style={wrap} className={className} onClick={() => setShowViewer(true)}>
        <video
          style={media}
          playsInline
          preload="metadata"
          muted
          onLoadedMetadata={(e) => {
            try { e.currentTarget.currentTime = 0.01; } catch {}
          }}
        >
          <source src={src} type={type} />
        </video>

        {/* small badge */}
        <div
          style={{
            position: "absolute",
            bottom: 8,
            right: 8,
            background: "rgba(0,0,0,.55)",
            color: "#fff",
            fontSize: 12,
            lineHeight: "16px",
            padding: "2px 6px",
            borderRadius: 6,
            pointerEvents: "none",
          }}
        >
          ▶
        </div>
      </div>
    );
  })();

  return (
    <>
      {tile}
      {showViewer && (
        <MediaViewer
          src={src}
          isVideo={isVideo}
          onClose={() => setShowViewer(false)}
        />
      )}
    </>
  );
};

export default MediaTile;
